const fetchNews = () => {
  const buttonEl = document.querySelector('.load-more')
  const wrapperEl = buttonEl.previousElementSibling.previousElementSibling
  const loadingEl = buttonEl.previousElementSibling
  const totalPosts = 6

  const increment = (newTotal) => buttonEl.setAttribute('data-offset', newTotal)

  const template = (post) => {
    const date = new Date(post.date)
    const options = { month: 'long' }
    const month = new Intl.DateTimeFormat('en-US', options).format(date)
    const formattedDate = `${date.getDate()} ${month} ${date.getFullYear()}`
    const media = post._embedded['wp:featuredmedia']['0']
    const thumb = media.media_details.sizes.thumbnail
    return `
      <article class="u-w-1/2 m:u-w-full u-px-16 u-py-20">
        <a href="${post.link}" class="u-flex">
          <img src="${thumb.source_url}"
              width="${thumb.width}" height="${thumb.height}"
              class="u-min-w-80 u-w-80 u-h-80 u-mr-10 u-object-cover wp-post-image" alt="${media.alt_text}" loading="lazy"
          />
          <div>
            <h3>${post.title.rendered}</h3>
            <p class="u-italic u-text-blue-primary"><time datetime="${formattedDate}">${formattedDate}</time></p>
          </div>
        </a>
      </article>
    `
  }

  const render = (posts) => {
    if (posts.length <= 5) {
      buttonEl.nextElementSibling.classList.remove('u-hidden')
      buttonEl.remove()
    }

    posts.map((post) => {
      const html = template(post)
      return wrapperEl.insertAdjacentHTML('beforeend', html)
    })
  }

  const loadPosts = async () => {
    loadingEl.classList.remove('u-hidden')
    const offset = Number(buttonEl.dataset.offset)
    const posts = await fetch(
      `${window.location.origin}/wp-json/wp/v2/news?_embed&per_page=${totalPosts}&offset=${offset}`,
    )
    const response = await posts.json()
    loadingEl.classList.add('u-hidden')
    increment(offset + totalPosts)
    render(response)
  }

  buttonEl.addEventListener('click', (e) => {
    e.preventDefault()
    loadPosts()
  })
}

export default fetchNews
